import {parseDate} from './parseDate';

const MILLISECONDS_PER_MINUTE = 60_000;

/**
 * @about Shifts a local Date so its UTC representation matches the local calendar date and time.
 * Use before UTC-based formatting (e.g. `toISOString()`) to preserve the user's intended date.
 *
 * @example
 * // User in CET (UTC+2) picks June 15 → browser creates 2025-06-15T00:00:00+02:00
 * // Internally stored as 2025-06-14T22:00:00Z
 * localDateToUtcDate(date).toISOString() // → '2025-06-15T00:00:00.000Z'
 */
export function localDateToUtcDate(date: Date) {
  return parseDate(date.getTime() - date.getTimezoneOffset() * MILLISECONDS_PER_MINUTE);
}
